<template>
   <AppLayout :title="title">
        
   </AppLayout>
</template>
<script setup lang="ts">
    import { ref } from "vue";
    import { useForm, usePage } from '@inertiajs/vue3';
    import { toast } from 'vue3-toastify';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import { SharedPageProps } from '@/Types/inertia';
    import { User } from '@/Types/Models/user';

    interface PageData extends SharedPageProps{
        data?:{
            user?: User,
        }
    }

    interface UserForm{
        id: number,
        firstname: string,
        lastname: string,
        email: string,
        password: string
    }

    
    const page = usePage<PageData>();
    const userForm = useForm<UserForm>({
        id:  page.props?.data?.user?.id ?? 0,
        firstname:  page.props?.data?.user?.firstname ?? '',
        lastname:  page.props?.data?.user?.lastname ?? '',
        email:  page.props?.data?.user?.email ?? '',
        password:  '',
    });
    const creating = ref<boolean>( page.props?.data?.user?.id ? false : true);
    const title = ref(creating.value ? 'Create User' : `Update User`);

    const manageUser = () => {

    };

</script>